import { Link } from "react-router-dom";
import { GrRefresh } from "react-icons/gr";
import ReportRow from "./ReportRow";
import { useHistory } from "react-router-dom";
import { AUTH_ROUTES } from "../../routes/Routes.types";

const Reports = ({ allReports, fetchReports }) => {

  const history = useHistory();
  const headings = [
    "Name",
    "Account",
    "From",
    "To",
    "Created at",
    "Created by",
    "Download",
  ];

  return (
    <div className="panel" style={{backgroundColor:"#F5F9FF"}}>
      <div className="pHead">
        <span className="h5">
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {" "}
            <g clip-path="url(#clip0_352_81032)">
              {" "}
              <path
                opacity="0.5"
                d="M28.8281 8.02441V33.0469C28.8281 34.2894 27.8207 35.2969 26.5781 35.2969H2.95312C1.71057 35.2969 0.703125 34.2894 0.703125 33.0469V2.95312C0.703125 1.71057 1.71057 0.703125 2.95312 0.703125H21.5156L28.8281 8.02441Z"
                fill="#73C3FD"
              />{" "}
              <path
                d="M21.5156 5.77176C21.5156 7.01431 22.5231 8.02176 23.7656 8.02176H28.8281L21.5156 0.700195V5.77176Z"
                fill="#F6BD3D"
              />{" "}
              <path
                d="M5.20312 6.3252H14.7656V11.9502H5.20312V6.3252Z"
                fill="white"
              />{" "}
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M34.6371 26.9778C34.6371 31.5722 30.9128 35.2966 26.3186 35.2966C21.7244 35.2966 18 31.5722 18 26.9778C18 22.3835 21.7244 18.6592 26.3186 18.6592C30.9128 18.6592 34.6371 22.3835 34.6371 26.9778Z"
                fill="white"
              />{" "}
              <path
                opacity="0.8"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M31.3628 26.9781C31.3628 29.7637 29.1045 32.0219 26.3189 32.0219C23.5334 32.0219 21.2754 29.7637 21.2754 26.9781C21.2754 24.1928 23.5334 21.9346 26.3189 21.9346C29.1045 21.9346 31.3628 24.1928 31.3628 26.9781Z"
                fill="#73C3FD"
              />{" "}
              <path
                d="M5.20312 12.6533H14.7656C15.154 12.6533 15.4687 12.3386 15.4687 11.9502V6.3252C15.4687 5.9371 15.154 5.62207 14.7656 5.62207H5.20312C4.81476 5.62207 4.5 5.9371 4.5 6.3252V11.9502C4.5 12.3386 4.81476 12.6533 5.20312 12.6533ZM5.90625 7.02832H14.0625V11.2471H5.90625V7.02832Z"
                fill="#171D34"
              />{" "}
              <path
                d="M18.6328 12.6533H24.3281C24.7162 12.6533 25.0312 12.3386 25.0312 11.9502C25.0312 11.5621 24.7162 11.2471 24.3281 11.2471H18.6328C18.2444 11.2471 17.9297 11.5621 17.9297 11.9502C17.9297 12.3386 18.2444 12.6533 18.6328 12.6533Z"
                fill="#171D34"
              />{" "}
              <path
                d="M16.519 16.8721H5.20312C4.81476 16.8721 4.5 17.1871 4.5 17.5752C4.5 17.9636 4.81476 18.2783 5.20312 18.2783H16.519C16.9074 18.2783 17.2222 17.9636 17.2222 17.5752C17.2222 17.1871 16.9074 16.8721 16.519 16.8721Z"
                fill="#171D34"
              />{" "}
              <path
                d="M19.7617 16.8721C19.5769 16.8721 19.3953 16.9473 19.2649 17.0781C19.1339 17.2088 19.0586 17.3904 19.0586 17.5752C19.0586 17.76 19.1339 17.9416 19.2649 18.0723C19.3953 18.2031 19.5769 18.2783 19.7617 18.2783C19.9466 18.2783 20.1281 18.2031 20.2588 18.0723C20.3896 17.9416 20.4648 17.76 20.4648 17.5752C20.4648 17.3904 20.3899 17.2088 20.2588 17.0781C20.1281 16.9473 19.9466 16.8721 19.7617 16.8721Z"
                fill="#171D34"
              />{" "}
              <path
                d="M15.3984 28.1221H8.29687C7.90851 28.1221 7.59375 28.4368 7.59375 28.8252C7.59375 29.2136 7.90851 29.5283 8.29687 29.5283H15.3984C15.7868 29.5283 16.1016 29.2136 16.1016 28.8252C16.1016 28.4368 15.7868 28.1221 15.3984 28.1221Z"
                fill="#171D34"
              />{" "}
              <path
                d="M5.28516 28.1221C5.10031 28.1221 4.91904 28.1973 4.7883 28.3281C4.65674 28.4588 4.58203 28.6404 4.58203 28.8252C4.58203 29.01 4.65674 29.1916 4.7883 29.3223C4.91904 29.4531 5.10031 29.5283 5.28516 29.5283C5.47028 29.5283 5.65155 29.4531 5.78229 29.3223C5.91302 29.1916 5.98828 29.01 5.98828 28.8252C5.98828 28.6404 5.9133 28.4588 5.78229 28.3281C5.65155 28.1973 5.47028 28.1221 5.28516 28.1221Z"
                fill="#171D34"
              />{" "}
              <path
                d="M15.6445 22.4971H5.20312C4.81476 22.4971 4.5 22.8118 4.5 23.2002C4.5 23.5886 4.81476 23.9033 5.20312 23.9033H15.6445C16.0329 23.9033 16.3477 23.5886 16.3477 23.2002C16.3477 22.8118 16.0329 22.4971 15.6445 22.4971Z"
                fill="#171D34"
              />{" "}
              <path
                d="M35.6753 23.5286L34.0409 22.4841C33.8579 22.3673 33.6316 22.3415 33.427 22.414C33.2224 22.4868 33.0628 22.65 32.9947 22.856L32.3704 24.7445C32.2484 25.1131 32.4484 25.5108 32.8172 25.6328C32.8906 25.6569 32.965 25.6685 33.0381 25.6685C33.3331 25.6685 33.608 25.4814 33.7055 25.1859L33.7157 25.1554C33.8607 25.7459 33.9343 26.3548 33.9343 26.978C33.9343 31.1776 30.5178 34.5938 26.3186 34.5938C22.1193 34.5938 18.7031 31.1773 18.7031 26.978C18.7031 22.7788 22.1193 19.3626 26.3186 19.3626C27.4051 19.3626 28.454 19.5864 29.4365 20.0278C29.7905 20.1868 30.2066 20.0286 30.3659 19.6746C30.5252 19.3203 30.367 18.9042 30.0127 18.7449C29.8537 18.6735 29.693 18.6073 29.5312 18.5455V8.02441C29.5312 7.8382 29.4574 7.65967 29.3255 7.52783L22.013 0.206268C21.8812 0.0741577 21.7024 0 21.5156 0H2.95312C1.32468 0 0 1.32468 0 2.95312V33.0469C0 34.675 1.32468 36 2.95312 36H26.5781C26.6116 36 26.6446 35.9967 26.677 35.9923C31.486 35.8033 35.3405 31.8329 35.3405 26.978C35.3405 26.2288 35.2504 25.4968 35.073 24.7871C35.3718 24.8876 35.7119 24.7775 35.8893 24.4998C36.0983 24.1724 36.0025 23.7376 35.6753 23.5286ZM22.2187 2.40189L27.1291 7.31827H23.7656C22.9125 7.31827 22.2187 6.62448 22.2187 5.77139V2.40189ZM2.95312 34.5938C2.10004 34.5938 1.40625 33.8997 1.40625 33.0469V2.95312C1.40625 2.10004 2.10004 1.40625 2.95312 1.40625H20.8125V5.62198H18.6328C18.2444 5.62198 17.9297 5.93701 17.9297 6.3251C17.9297 6.71347 18.2444 7.02823 18.6328 7.02823H21.094C21.567 8.02991 22.5865 8.72479 23.7656 8.72479H28.125V18.1373C27.535 18.0173 26.9319 17.9563 26.3186 17.9563C21.344 17.9563 17.2969 22.0034 17.2969 26.978C17.2969 30.1764 18.9701 32.9911 21.4868 34.5938H2.95312Z"
                fill="#171D34"
              />{" "}
              <path
                d="M26.3189 21.2314C23.1502 21.2314 20.5723 23.8094 20.5723 26.9781C20.5723 30.1469 23.1502 32.7251 26.3189 32.7251C29.4877 32.7251 32.0659 30.1469 32.0659 26.9781C32.0659 23.8094 29.4877 21.2314 26.3189 21.2314ZM26.3189 31.3188C23.9256 31.3188 21.9785 29.3715 21.9785 26.9781C21.9785 24.585 23.9256 22.6377 26.3189 22.6377C28.7123 22.6377 30.6596 24.585 30.6596 26.9781C30.6596 29.3715 28.7123 31.3188 26.3189 31.3188Z"
                fill="#171D34"
              />{" "}
              <path
                d="M27.5405 26.274H27.0225V24.5C27.0225 24.1116 26.7077 23.7969 26.3193 23.7969C25.9312 23.7969 25.6162 24.1116 25.6162 24.5V26.9771C25.6162 27.3655 25.9312 27.6803 26.3193 27.6803H27.5405C27.9288 27.6803 28.2436 27.3655 28.2436 26.9771C28.2436 26.5891 27.9288 26.274 27.5405 26.274Z"
                fill="#171D34"
              />{" "}
            </g>{" "}
            <defs>
              {" "}
              <clipPath id="clip0_352_81032">
                {" "}
                <rect width="36" height="36" fill="white" />{" "}
              </clipPath>{" "}
            </defs>{" "}
          </svg>{" "}
          Reports
        </span>
        {/* <div className="control">
          {allReports.length > 0 && (
            <Link className="btn btnPrimary" to="/reports">
              View all
            </Link>
          )}
        </div> */}
        <div className="control">
          {/* refresh button uncomment when you need */}
          {/* <div className="control__icon" onClick={fetchReports}>
            <GrRefresh size={26} />
          </div> */}
          <button className="btn btnPrimary" type="button" 
                                            onClick={()=>{history.push(AUTH_ROUTES.REPORTS)}}
                                            >View
                                            </button>


        </div>
      </div>
      <div className="pBody pb-0">
        <div className="tableOuter maxHeight">
          {allReports.length > 0 ? (
            <table className="table customGrid">
              <thead>
                <tr>
                  {headings.map((e, index) => {
                    return <th key={index}>{e}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {allReports.map((e, key) => {
                  return (
                    <>
                      <ReportRow
                        key={key}
                        data={e}
                        index={key}
                        showCheckbox={false}
                      />
                    </>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <p className="heading-6 text-center">No Reports to Show</p>
          )}
        </div>
      </div>
      <span className='moreBtn'><svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2.5625 1.625C2.5625 1.81042 2.50752 1.99168 2.4045 2.14585C2.30149 2.30002 2.15507 2.42018 1.98377 2.49114C1.81246 2.56209 1.62396 2.58066 1.4421 2.54449C1.26025 2.50831 1.0932 2.41902 0.962088 2.28791C0.830976 2.1568 0.741688 1.98975 0.705514 1.8079C0.669341 1.62604 0.687906 1.43754 0.758863 1.26623C0.829821 1.09493 0.949982 0.948511 1.10415 0.845498C1.25832 0.742484 1.43958 0.6875 1.625 0.6875C1.87364 0.6875 2.1121 0.786272 2.28791 0.962088C2.46373 1.1379 2.5625 1.37636 2.5625 1.625ZM8 0.6875C7.81458 0.6875 7.63332 0.742484 7.47915 0.845498C7.32498 0.948511 7.20482 1.09493 7.13386 1.26623C7.06291 1.43754 7.04434 1.62604 7.08051 1.8079C7.11669 1.98975 7.20598 2.1568 7.33709 2.28791C7.4682 2.41902 7.63525 2.50831 7.8171 2.54449C7.99896 2.58066 8.18746 2.56209 8.35877 2.49114C8.53007 2.42018 8.67649 2.30002 8.7795 2.14585C8.88252 1.99168 8.9375 1.81042 8.9375 1.625C8.9375 1.37636 8.83873 1.1379 8.66291 0.962088C8.4871 0.786272 8.24864 0.6875 8 0.6875ZM14.375 2.5625C14.5604 2.5625 14.7417 2.50752 14.8958 2.4045C15.05 2.30149 15.1702 2.15507 15.2411 1.98377C15.3121 1.81246 15.3307 1.62396 15.2945 1.4421C15.2583 1.26025 15.169 1.0932 15.0379 0.962088C14.9068 0.830976 14.7398 0.741688 14.5579 0.705514C14.376 0.66934 14.1875 0.687906 14.0162 0.758864C13.8449 0.829821 13.6985 0.949982 13.5955 1.10415C13.4925 1.25832 13.4375 1.43958 13.4375 1.625C13.4375 1.87364 13.5363 2.1121 13.7121 2.28791C13.8879 2.46373 14.1264 2.5625 14.375 2.5625ZM1.625 7.4375C1.43958 7.4375 1.25832 7.49248 1.10415 7.5955C0.949982 7.69851 0.829821 7.84493 0.758863 8.01624C0.687906 8.18754 0.669341 8.37604 0.705514 8.5579C0.741688 8.73975 0.830976 8.9068 0.962088 9.03791C1.0932 9.16903 1.26025 9.25831 1.4421 9.29449C1.62396 9.33066 1.81246 9.3121 1.98377 9.24114C2.15507 9.17018 2.30149 9.05002 2.4045 8.89585C2.50752 8.74168 2.5625 8.56042 2.5625 8.375C2.5625 8.12636 2.46373 7.8879 2.28791 7.71209C2.1121 7.53627 1.87364 7.4375 1.625 7.4375ZM8 7.4375C7.81458 7.4375 7.63332 7.49248 7.47915 7.5955C7.32498 7.69851 7.20482 7.84493 7.13386 8.01624C7.06291 8.18754 7.04434 8.37604 7.08051 8.5579C7.11669 8.73975 7.20598 8.9068 7.33709 9.03791C7.4682 9.16903 7.63525 9.25831 7.8171 9.29449C7.99896 9.33066 8.18746 9.3121 8.35877 9.24114C8.53007 9.17018 8.67649 9.05002 8.7795 8.89585C8.88252 8.74168 8.9375 8.56042 8.9375 8.375C8.9375 8.12636 8.83873 7.8879 8.66291 7.71209C8.4871 7.53627 8.24864 7.4375 8 7.4375ZM14.375 7.4375C14.1896 7.4375 14.0083 7.49248 13.8542 7.5955C13.7 7.69851 13.5798 7.84493 13.5089 8.01624C13.4379 8.18754 13.4193 8.37604 13.4555 8.5579C13.4917 8.73975 13.581 8.9068 13.7121 9.03791C13.8432 9.16903 14.0102 9.25831 14.1921 9.29449C14.374 9.33066 14.5625 9.3121 14.7338 9.24114C14.9051 9.17018 15.0515 9.05002 15.1545 8.89585C15.2575 8.74168 15.3125 8.56042 15.3125 8.375C15.3125 8.12636 15.2137 7.8879 15.0379 7.71209C14.8621 7.53627 14.6236 7.4375 14.375 7.4375Z" fill="#171D34"/> </svg></span>
    </div>
  );
};

export default Reports;
